<div class="signers-header">Recent Signers</div>
<table>
  @for (signer of signers; track signer) {
    <tr class="signer">
      <td>
        <div class="country">{{ signer.location }}</div>
      </td>
      <td>
        <div class="name">{{ signer.name }}</div>
      </td>
      <td>
        <div class="when">
          <tyt-timestamp [value]="signer.timestamp * 1000"></tyt-timestamp>
        </div>
      </td>
    </tr>
  }
</table>
@if (!signers || signers.length === 0) {
  <div class="no-sign-yet">Be the first to sign!</div>
}